export enum CarouselVariant {
  GRID = 'grid',
  SLIDER = 'slider',
}

export enum SliderBackgroundVariant {
  BLUR = 'blur',
  BLACK = 'black',
}
